export enum SidebarType {
    RECORD_SETTINGS = 'recordSettings',
    REQUESTS_SETTINGS = 'requestsSettings',
    PROJECT_SETTINGS = 'projectSettings',
    ASSISTANT_SHOP = 'assistantShop',
    CITATIONS = 'citations',
    NOTIFICATIONS = 'notifications',
    NOTIFICATIONS_SETTINGS = 'notificationsSettings',
}
